module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vux-server-render-support-18.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/vux-server-render-support.md
// module id = 595
// module chunks = 193